import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { EditOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Button, Select, Row, Col } from 'antd';
import CustomerUpdateModal from "./CustomerUpdateModal";
import LazyLoadSelect, {} from "../../components/LazyLoadSelect";
import HasPermissions from "../../../../containers/HasPermissions";
const CustomerSelect = ({ tenantId, debtorId, disabled = false, allowClear = true, mustHaveDebtor, showCrudButtons = true, value, placeholder = "Select Customer", onChange, onCustomerSelected }) => {
    const selectRef = useRef(null);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [editCustomer, setEditCustomer] = useState(undefined);
    useEffect(() => {
        if (debtorId) {
            // Clear selection if the debtor is changed
            onChange && onChange(null);
        }
    }, [debtorId]);
    const optionsRenderer = (customers) => {
        return customers.map((customer) => {
            let label = customer.name;
            if (customer.podEmailCsv) {
                label += " - " + customer.podEmailCsv;
            }
            return _jsx(Select.Option, { value: customer.id, filter: customer.name, children: label }, customer.id);
        });
    };
    const onSelected = (customer) => {
        setEditCustomer(customer);
        onCustomerSelected && onCustomerSelected(customer);
        onChange && onChange(customer?.id);
    };
    const onAddButtonClicked = () => {
        setShowUpdateModal(true);
        setEditCustomer(undefined);
    };
    const onEditButtonClicked = () => {
        setShowUpdateModal(true);
    };
    const hideUpdateModal = () => {
        setShowUpdateModal(false);
    };
    const addOrUpdateCustomer = (customer) => {
        selectRef.current?.update(customer);
        setEditCustomer(customer);
        onCustomerSelected && onCustomerSelected(customer);
        onChange && onChange(customer.id);
    };
    const editDisabled = disabled || value == null;
    return (_jsxs(Row, { wrap: false, children: [_jsx(Col, { flex: "auto", children: _jsx(LazyLoadSelect, { style: { width: '100%' }, ref: selectRef, disabled: disabled, allowClear: allowClear, placeholder: placeholder, url: "/admin/v1/customers", tenantId: tenantId, notFoundMessage: "No customers found", searchKey: "nameLike", queryParams: {
                        enabled: true,
                        mustHaveDebtor,
                        debtorId
                    }, onChange: onChange, onSelected: onSelected, optionsRenderer: optionsRenderer, value: value }) }), showCrudButtons &&
                _jsx(HasPermissions, { permissions: ['admin:customer:update'], children: _jsx(Col, { flex: "51px", children: _jsx(Button, { htmlType: "button", disabled: editDisabled, style: { marginLeft: "5px" }, type: "default", onClick: onEditButtonClicked, children: _jsx(EditOutlined, {}) }) }) }), showCrudButtons &&
                _jsx(HasPermissions, { permissions: ['admin:customer:create'], children: _jsx(Col, { flex: "51px", children: _jsx(Button, { htmlType: "button", disabled: disabled, style: { marginLeft: "5px" }, type: "default", onClick: onAddButtonClicked, children: _jsx(PlusCircleOutlined, {}) }) }) }), showCrudButtons &&
                _jsx(CustomerUpdateModal, { open: showUpdateModal, customer: editCustomer, tenantId: tenantId, onSave: customer => {
                        hideUpdateModal();
                        addOrUpdateCustomer(customer);
                    }, onCancel: hideUpdateModal })] }));
};
export default CustomerSelect;
